<template>
  <div>
    <custom-callout
      :border-color-hex="statusSetColor"
      class-main="mt-3 rounded"
      :has-toggle="false"
    >
      <div class="row py-2 mr-md-0 align-items-center">
        <div class="col-12 col-md-2">
          <div class="d-flex flex-column color-black mr-2">
            <div
              :class="
                `mb-1 font-light badge badge-pill font-16 py-2 mt-2 w-90 mx-auto badge-${statusColor}`
              "
            >
              {{ statusDocument }}
            </div>
          </div>
        </div>
        <div class="col-md-8 border-left">
          <div class="row mb-3">
            <div class="col-12 col-md-6 my-2">
              <span class="data-title d-block border-mobile">Estudiante:</span>
              <span class="font-16 color-black">
                {{ formatedFullName | empty }}
              </span>
            </div>
            <div class="col-12 col-md-3 my-2">
              <span class="data-title d-block">Número de Contrato:</span>
              <span class="font-16 color-black">
                {{ data.contractNumber | empty }}
              </span>
            </div>
            <div class="col-12 col-md-3 my-2">
              <span class="data-title d-block">Documento:</span>
              <span class="font-16 color-black">
                {{ data.document | empty }}
              </span>
            </div>
          </div>
        </div>
        <div
          class="col col-md-2 col-12"
          :class="!isMobile ? 'd-flex justify-content-center p-0' : 'mt-2'"
        >
          <div v-if="data.uploaded" class="row justify-content-center">
            <div>
              <action-button
                id="actionBtnDownloadDocumentPdf"
                i="fas fa-file-download pl-2 mx-0"
                variant="success px-1 mx-1"
                @click="downloadDocument"
              />
            </div>
            <div v-if="isPreliminaroNoExiste && data.finalized">
              <action-button
                id="actionBtnReplaceDocumentPdf"
                i=" fas fa-file-plus pl-2 mx-0"
                variant="outline-success px-1 mx-1"
                @click="onShowInputFile"
              />
            </div>
          </div>
        </div>
      </div>
    </custom-callout>
    <input
      id="inputFileForUploadingSingleCertification"
      ref="uploadFile"
      accept=".pdf"
      style="display: none"
      type="file"
      @change="showCertificationModal"
    />
    <custom-modal
      :cancel-icon="'fas fa-times-circle'"
      :cancel-text="'Cerrar'"
      fit-height-content
      icon="fas fa-exclamation-circle"
      is-centered
      :save-icon="''"
      :save-text="'Aceptar'"
      show-cancel
      show-save
      :title="'Certificación'"
      :value="showModal"
      :width="'740px'"
      @cancel="onCancelAcceptTermHandler"
      @save="onAcceptTermHandler"
    >
      <custom-checkbox-single-option
        v-model="acceptedTerms"
        class="font-weight-bold"
        :option-text="'Acepto los términos y responsabilidades'"
        :title="
          'Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)'
        "
      />
    </custom-modal>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomModal from 'CustomModal';
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';
import store, { modulesName } from '@/store/index';
import utilities from '@/utils/utilities.js';
import billingStatus from '@/utils/constants/billingStatus';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';
import { uploadCertificationFiles as _uploadCertificationFiles } from '@/services/provider/services-month-certification.api.js';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api';

export default {
  name: 'ResultRow',
  mixins: [alertMixin],
  components: {
    CustomCallout,
    ActionButton,
    CustomModal,
    CustomCheckboxSingleOption,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    setErrorModel: {
      type: Function,
    },
    onRefresh: {
      type: Function,
    },
  },
  data: () => ({
    showModal: false,
    acceptedTerms: false,
    selectedFile: [],
  }),
  computed: {
    formatedFullName() {
      return `${this.data.studentFullName} - ${this.data.studentSieId}`;
    },
    statusDocument() {
      return this.data.uploaded ? 'Cargado' : 'Pendiente';
    },
    isMobile() {
      return store.getters[`${modulesName.appModuleName}/getIsMobileDensity`];
    },
    statusColor() {
      return utilities.parseStateColorCertificationByStatus(this.data.uploaded);
    },
    statusSetColor() {
      return this.data.uploaded ? '#a3e5b3' : '#fced7b';
    },
    isPreliminaroNoExiste() {
      return (
        this.data.billingStatusId === billingStatus.Preliminar ||
        this.data.billingStatusId === billingStatus.NoExiste
      );
    },
    initialErrorModel() {
      return {
        validations: [],
        showAlert: false,
        failedUploadsCount: 0,
      };
    },
  },
  methods: {
    onShowInputFile() {
      this.$refs.uploadFile.click();
    },
    downloadDocument() {
      _downloadDocumentByAttachmentId(this.data.documentId);
    },
    async onReplaceFile(files) {
      if (files.length > 0) {
        const selectedFile = files[0];
        const filename = files[0].name.split('.')[0];

        const contractNumber = this.data.contractNumber.toString();
        const errorModel = this.initialErrorModel;

        if (contractNumber !== filename) {
          errorModel.validations = [
            {
              fileName: selectedFile.name,
              description: `Documento incorrecto para Contrato ${contractNumber}`,
            },
          ];
          errorModel.showAlert = true;
          errorModel.failedUploadsCount = 1;
          this.setErrorModel(errorModel);
          return;
        }

        let formData = new FormData();

        formData.append('files[0].contractId', this.data.contractId);
        formData.append('files[0].visitSummaryId', this.data.visitSummaryId);
        formData.append('files[0].documentId', this.data.documentId);
        formData.append(
          'files[0].disciplineTypeId',
          this.data.disciplineTypeId
        );
        formData.append('files[0].studentSieId', this.data.studentSieId);
        formData.append('files[0].contractNumber', this.data.contractNumber);
        formData.append('files[0].file', selectedFile);

        await _uploadCertificationFiles(formData)
          .then((res) => {
            this.$refs.uploadFile.value = null;
            this.setErrorModel(this.initialErrorModel);

            if (res?.data) {
              if (res.data?.errorMessages?.length > 0) {
                errorModel.validations = res.data.errorMessages;
                errorModel.showAlert = true;
                errorModel.failedUploadsCount = res.data.failedUploads;
                this.setErrorModel(errorModel);
                return;
              }

              this.ShowToast(
                'Proceso Exitoso',
                'Se ha cargado el documento exitosamente.',
                'success'
              );
              this.onRefresh();
            }
          })
          .catch((err) => {
            this.ShowToast('Alerta', err.response.data.message, 'error');
          });
      }
    },
    onCancelAcceptTermHandler() {
      this.showModal = false;
      this.acceptedTerms = false;
      this.selectedFile = [];
      this.$refs.uploadFile.value = null;
    },
    onAcceptTermHandler() {
      if (!this.acceptedTerms) {
        this.ShowToast(
          'Alerta',
          'Favor certifique el documento  que ha subido al sistema REMpro.',
          'error'
        );
        return;
      }
      this.showModal = false;
      this.acceptedTerms = false;
      this.onReplaceFile(this.selectedFile);
    },
    showCertificationModal(e) {
      if (e.target.files && e.target.files.length > 0) {
        this.showModal = true;
        this.selectedFile = Array.from(e.target.files)?.map((file) => file);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.badge-yellow {
  background-color: #fced7b;
}

.badge-green-light {
  background-color: #a3e5b3;
}

.font-light {
  font-weight: 400;
}
</style>
